import { css } from '@emotion/react'

const matrixChatWrapper = css`
  background: #fff;

  .conversation-header {
    border-bottom: solid 1px var(--color-monochrome-medium);
  }

  .conversation-banners {
    position: absolute;
    width: 100%;
    top: 54px;
    z-index: 10;

    > div {
      border-bottom: solid 1px var(--color-monochrome-medium);

      &:last-of-type {
        border-bottom-color: tranparent;
      }
    }
  }
`

export const styles = {
  matrixChatWrapper,
}
